import { GET_OVERTREDELSEGRUPPER_URL } from "../constants/api";
import * as axiosUtils from "../utils/axiosUtils";

export const actionType = "OVERTREDELSESKODER_ILEGGELSER_GRUPPER";

export function getOvertredelsegrupper() {
  return axiosUtils.GetAll(GET_OVERTREDELSEGRUPPER_URL, actionType);
}
